/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b9b9b9}.ui-inputtext[_ngcontent-%COMP%]{padding:.429em 1.42em!important}\n/*# sourceMappingURL=input-box.component.css.map*/"];
export { styles as styles };
